import React from "react";
import { useParams, Link } from "react-router-dom";
import "animate.css";

import Navbar from "../Navbar/Navbar";
import MainBodyContainer from "../Common/Body/MainBodyContainer/MainBodyContainer";
import Footer from "../Footer/Footer";
import { GetInvolvedData } from "../Data/GetInvolvedData";

import "./GetInvolved.css";

const GetInvolvedPage = () => {
  const { id } = useParams();

  // Map route IDs to data sections
  const pageMapping = {
    "volunteer": "volunteer",
    "partner": "partner"
  };

  const dataKey = pageMapping[id];
  const pageData = dataKey ? GetInvolvedData[dataKey] : null;

  // If Contact page, redirect
  if (id === "contact") {
    window.location.href = "/contact";
    return null;
  }

  if (!pageData) {
    return (
      <div>
        <Navbar />
        <MainBodyContainer heading={"Page Not Found"}>
          <div className="not-found">
            <h2>Page not found</h2>
            <p>The page you're looking for doesn't exist.</p>
            <Link to="/" className="back-link">
              ← Back to Home
            </Link>
          </div>
        </MainBodyContainer>
        <Footer />
      </div>
    );
  }


  // Render Volunteer page
  if (id === "volunteer") {
    return (
      <div>
        <Navbar />
        <MainBodyContainer heading={pageData.pageTitle}>
          <div className="get-involved-hero">
            <h1 className="animate__animated animate__fadeInUp">{pageData.pageTitle}</h1>
            <p className="hero-tagline">{pageData.tagline}</p>
          </div>

          {/* Why Volunteer */}
          {pageData.whyVolunteer && (
            <div className="detail-section">
              <h2 className="section-header">Why Volunteer With Us?</h2>
              <div className="benefits-grid">
                {pageData.whyVolunteer.map((benefit, index) => (
                  <div key={index} className="benefit-item">
                    <span className="benefit-icon">✓</span>
                    <span>{benefit}</span>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Volunteer Roles */}
          {pageData.volunteerRoles && (
            <div className="detail-section roles-section">
              <h2 className="section-header">Volunteer Opportunities</h2>
              <div className="roles-grid">
                {pageData.volunteerRoles.map((role, index) => (
                  <div key={index} className="role-card">
                    <h3 className="role-title">{role.role}</h3>
                    <p className="role-description">{role.description}</p>
                    <div className="role-details">
                      <p><strong>Time:</strong> {role.timeCommitment}</p>
                      <p><strong>Skills:</strong> {role.skillsNeeded}</p>
                      <p><strong>Impact:</strong> {role.impact}</p>
                      {role.idealFor && <p><strong>Ideal for:</strong> {role.idealFor}</p>}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Former Clients Section */}
          {pageData.formerClients && (
            <div className="detail-section former-clients-section">
              <div className="former-clients-card">
                <h2>{pageData.formerClients.title}</h2>
                <p>{pageData.formerClients.description}</p>
                <p className="former-clients-message">{pageData.formerClients.message}</p>
              </div>
            </div>
          )}

          {/* CTA */}
          <div className="get-involved-cta">
            <h2>Ready to Make a Difference?</h2>
            <p>Get in touch to discuss volunteer opportunities that match your skills and availability.</p>
            <div className="cta-buttons">
              <Link to="/contact" className="cta-button primary">
                Apply to Volunteer
              </Link>
            </div>
          </div>
        </MainBodyContainer>
        <Footer />
      </div>
    );
  }

  // Render Partner page
  if (id === "partner") {
    return (
      <div>
        <Navbar />
        <MainBodyContainer heading={pageData.pageTitle}>
          <div className="get-involved-hero">
            <h1 className="animate__animated animate__fadeInUp">{pageData.pageTitle}</h1>
            <p className="hero-tagline">{pageData.tagline}</p>
          </div>

          {/* For Employers */}
          {pageData.forEmployers && (
            <div className="detail-section partner-section">
              <h2 className="section-header">{pageData.forEmployers.title}</h2>
              <p className="section-description">{pageData.forEmployers.description}</p>
              {pageData.forEmployers.opportunities && (
                <div className="opportunities-grid">
                  {pageData.forEmployers.opportunities.map((opp, index) => (
                    <div key={index} className="opportunity-card">
                      <h3>{opp.type}</h3>
                      <p>{opp.description}</p>
                      {opp.benefits && (
                        <ul className="benefits-list">
                          {opp.benefits.map((benefit, i) => (
                            <li key={i}>{benefit}</li>
                          ))}
                        </ul>
                      )}
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}

          {/* CTA */}
          <div className="get-involved-cta">
            <h2>Interested in Partnering?</h2>
            <p>Contact us to discuss how we can work together to create community impact.</p>
            <div className="cta-buttons">
              <Link to="/contact" className="cta-button primary">
                Discuss Partnership
              </Link>
              <Link to="/about/partnerships" className="cta-button secondary">
                View Current Partners
              </Link>
            </div>
          </div>
        </MainBodyContainer>
        <Footer />
      </div>
    );
  }

  return null;
};

export default GetInvolvedPage;
